module.exports = __webpack_public_path__ + "img/no-inbox.37f3d0a6.svg";